/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Quote_1_TextInputs */

const da_forside_quote_1_text = /** @type {(inputs: Forside_Quote_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeg plejer at bruge en hel weekend på terminsprøven i 9. klasse. Denne gang var jeg igennem 24 besvarelser på en eftermiddag – og brugte tiden på at tjekke i stedet for at tælle point.`)
};

/** @type {(inputs: Forside_Quote_1_TextInputs) => LocalizedString} */
const en_forside_quote_1_text = da_forside_quote_1_text;

/**

* @param {Forside_Quote_1_TextInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_quote_1_text = /** @type {((inputs?: Forside_Quote_1_TextInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Quote_1_TextInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_quote_1_text(inputs)
	return /** @type {LocalizedString} */ ("Jeg plejer at bruge en hel weekend på terminsprøven i 9. klasse. Denne gang var jeg igennem 24 besvarelser på en eftermiddag – og brugte tiden på at tjekke i stedet for at tælle point.")
});